import type React from "react";
import {StatChip} from "~/components/StatChip/StatChip";
import {COLORS} from "~/style/colors-ts";
import ChartIcon from "~/icons/svg/ChartIcon.svg?react";
import {useRevenueShareQuery} from "~/pages/supplier-360/hooks/useRevenueShareQuery";
import {BAND_LABEL, formatShare, formatUsdRange} from "./pdlFormat";

/** Header "Share of revenue: 3.1% · moderate leverage" — hidden when there's no usable revenue figure. */
export const RevenueShareChip: React.FC<{entityId: number}> = ({entityId}) => {
    const {data: share} = useRevenueShareQuery(entityId);
    if (!share) return null;

    const revenue = formatUsdRange(share.revenue_min_usd ?? share.revenue_usd, share.revenue_max_usd);
    return (
        <StatChip
            icon={{element: <ChartIcon/>, color: share.band === 'critical_leverage' ? COLORS.error.main : COLORS.info.main}}
            title="Share of revenue"
            value={`${formatShare(share)} · ${BAND_LABEL[share.band]}`}
            tooltip={{type: share.band === 'critical_leverage' ? 'warning' : 'info', text: `Supplier revenue: ${revenue}.`}}
        />
    );
};
